import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Lançamento de Notas',
    path: '/academico/lancamento_notas',
    name: 'lancamento_notas',
    component: () => import('@/views/academico/notas/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.LANCAMENTODENOTASEFALTAS_MENU_300302201
      ],
    },
    goesToMenu: true,
  },
]

